import { ReadJsonDataWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ReadJsonData')
export class ReadJsonDataConnectorProvider extends ConnectorProvider<ReadJsonDataWorkflowNode> {}
